import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BloomingData } from '../types/blooming-data';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})

export class BloomingDataService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.apiUrl}/livedata/`;
  }

  getItems(from?: Date){
    const url =  from ? `${this.baseUrl}?from=${format(from, 'yyyy-MM-dd')}`: this.baseUrl;
    return this.http.get<Array<BloomingData>>(url);
  }

  getLivedata(year?: number) {
    const query = new URLSearchParams();
    if (year && year > 0) {
      query.set('year', `${year}`);
    }
    const url = query.size > 0 ? `${this.baseUrl}?${query.toString()}` : this.baseUrl;
    return this.http.get<Array<BloomingData>>(url);
  }

}
